import React from 'react'

import Aux from 'hoc/ReactAux/ReactAux'
import { trackingHeading } from '../../../config/guestOrdering'

const STEPS = [
  { number: 'ONE', title: 'Awaiting Preparation' },
  { number: 'TWO', title: 'Awaiting Pickup' },
  { number: 'THREE', title: 'On The Way' },
  { number: 'FOUR', title: 'Delivered' },
]

// Which step is lit for each delivery status. DBO is tracked by no step.
const CURRENT_STEP = {
  NOT_MADE: 0,
  WAITING: 1,
  IN_TRANSIT: 2,
  DONE: 3,
  DBO: -1,
}

// The lit step icon is the only colour cue, so the current step also has a "Now" pill
// and carries aria-current for screen readers.
const DeliveryTrackingItem = (props) => {
  const status = props.order.statusOrderDelivery
  if (!(status in CURRENT_STEP)) {
    return null
  }
  const current = CURRENT_STEP[status]

  return (
    <Aux>
      <span>{trackingHeading(props.order)}</span>
      <div className="steps">
        {STEPS.map((step, index) => {
          const isCurrent = index === current
          return (
            <div
              key={step.number}
              className={`step ${step.number.toLowerCase()}`}
              aria-current={isCurrent ? 'step' : undefined}
            >
              <div className={`s${index + 1}-${isCurrent ? 'on' : 'off'}`}></div>
              <div className="step-info">
                <h4>STEP {step.number}</h4>
                <h3>
                  {step.title}
                  {/* A real space, so the title and the pill aren't read as one word. */}
                  {isCurrent ? ' ' : null}
                  {isCurrent ? <span className="step-now">Now</span> : null}
                </h3>
              </div>
            </div>
          )
        })}
      </div>
      <span className="arrival-time">
        {status === 'DBO'
          ? "We can't track this order"
          : `Estimated Arrival Time ${props.order.deliveryDateFormatted}`}
      </span>
    </Aux>
  )
}

export default DeliveryTrackingItem



// WEBPACK FOOTER //
// ./src/containers/DeliveryTracking/DeliveryTrackingItem/index.js